import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";

// Autocomplétion des communes françaises (API officielle geo.api.gouv.fr, sans clé).
export const CityAutocomplete = ({
  value,
  onChange,
  onSelect,
  placeholder = "Commence à taper ta ville…",
  testId = "city-autocomplete",
  className = "",
}) => {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 2) {
      setResults([]);
      return;
    }
    const t = setTimeout(async () => {
      try {
        const res = await fetch(
          `https://geo.api.gouv.fr/communes?nom=${encodeURIComponent(q)}&fields=nom,codesPostaux,population&limit=6&boost=population`
        );
        const data = await res.json();
        setResults(Array.isArray(data) ? data : []);
        setOpen(true);
      } catch {
        setResults([]);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [value]);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="relative" ref={box}>
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => results.length > 0 && setOpen(true)}
        placeholder={placeholder}
        autoComplete="off"
        className={`w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors ${className}`}
      />
      {open && results.length > 0 && (
        <ul
          data-testid={`${testId}-results`}
          className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-lg"
        >
          {results.map((c) => (
            <li key={c.code}>
              <button
                type="button"
                data-testid={`${testId}-option-${c.code}`}
                onClick={() => {
                  onSelect(c);
                  setOpen(false);
                }}
                className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm hover:bg-neutral-50 transition-colors"
              >
                <MapPin className="h-3.5 w-3.5 text-brand" />
                <span className="font-semibold">{c.nom}</span>
                <span className="text-neutral-500">{(c.codesPostaux || [])[0]}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
